<script context="module" lang="ts">
  import { serverOrClientUserStorePageLoadFunction } from '$lib/stores/getUserStore';
  import type { ClientUserStore } from 'shared/src';
  export const load = serverOrClientUserStorePageLoadFunction;
</script>

<script lang="ts">
  import Skills from '$lib/app/skills/Skills.svelte';
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';
  import LoadingSpinner from '$lib/components/LoadingSpinner.svelte';

  export let clientUserStore: ClientUserStore | undefined = undefined;
</script>

<PageTitle
  title="Skills"
  description="Practice music theory, rhythm and ear training skills."
  hideTitle
/>
{#if clientUserStore}
  <Skills {clientUserStore} />
{:else}
  <LoadingSpinner />
{/if}
